import initVueApp from "@/core.js";
const component = require(`./../views/IndexSaleFeb24.vue`).default;
require("@/myfont.font.js");
initVueApp(component);
